define("settings/components/cancelled-plan-overview", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "later/utils/compare-strings", "later/utils/plans-data", "@ember/template-factory"], function (_exports, _component, _service, _component2, _compareStrings, plansData, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"later/utils/compare-strings",0,"later/utils/plans-data",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.canReactivatePlan}}
    <div class="tAC--section__item">
      <p class="u--text--md u--float--left u--m__t__xs u--m__b__0">
        {{t "account.overview.subscription_overview.reactivate_title" plan=this.planName}}
      </p>
      <ul class="tAC--section__ul">
        {{#each this.features as |feature|}}
          <li class="tAC--section__li">
            {{feature}}
          </li>
        {{/each}}
      </ul>
    </div>
  
    <hr class="tAC--section__divider" />
  {{/if}}
  */
  {
    "id": "GUw6STTp",
    "block": "[[[41,[30,0,[\"canReactivatePlan\"]],[[[1,\"  \"],[10,0],[14,0,\"tAC--section__item\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md u--float--left u--m__t__xs u--m__b__0\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"account.overview.subscription_overview.reactivate_title\"],[[\"plan\"],[[30,0,[\"planName\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"tAC--section__ul\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"features\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"tAC--section__li\"],[12],[1,\"\\n          \"],[1,[30,1]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13],[1,\"\\n\"]],[]],null]],[\"feature\"],false,[\"if\",\"t\",\"each\",\"-track-array\"]]",
    "moduleName": "settings/components/cancelled-plan-overview.hbs",
    "isStrictMode": false
  });
  let CancelledPlanOverviewComponent = _exports.default = (_class = class CancelledPlanOverviewComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "locale", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _initializerDefineProperty(this, "auth", _descriptor4, this);
      _defineProperty(this, "highlightsMap", plansData.highlightsMap(this.intl, this.locale));
      _defineProperty(this, "legacyPlans", plansData.legacyPlans(this.intl));
    }
    get canReactivatePlan() {
      return this.subscriptions.subscriptionPlan.active;
    }
    get planName() {
      return this.subscriptions.subscriptionPlan.displayName;
    }
    get features() {
      if (this.subscriptions.isOnAgencyPlan) {
        // Note: using advanced plan reactivation highlights for scale plans
        return this.highlightsMap.advanced(this.subscriptions.subscriptionPlan).reactivationHighlights;
      }
      const {
        planType
      } = this.subscriptions.subscriptionPlan;
      const planHighlights = planType in this.highlightsMap ? this.highlightsMap[planType](this.subscriptions.subscriptionPlan) : {};
      const planData = this.auth.currentAccount.isOnLegacyPlan ? this.legacyPlans.find(legacyPlan => (0, _compareStrings.areStringsEqual)(legacyPlan.canonicalName, planType)) : planHighlights;
      return planData.reactivationHighlights;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CancelledPlanOverviewComponent);
});